module.exports = __webpack_public_path__ + "img/table.5ab70963.svg";